var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCategory({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3226_9111",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333984,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3226_9111)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.83398 11L12.334 2L17.834 11H6.83398ZM17.834 22C16.584 22 15.5215 21.5625 14.6465 20.6875C13.7715 19.8125 13.334 18.75 13.334 17.5C13.334 16.25 13.7715 15.1875 14.6465 14.3125C15.5215 13.4375 16.584 13 17.834 13C19.084 13 20.1465 13.4375 21.0215 14.3125C21.8965 15.1875 22.334 16.25 22.334 17.5C22.334 18.75 21.8965 19.8125 21.0215 20.6875C20.1465 21.5625 19.084 22 17.834 22ZM3.33398 21.5V13.5H11.334V21.5H3.33398ZM17.834 20C18.534 20 19.1257 19.7583 19.609 19.275C20.0923 18.7917 20.334 18.2 20.334 17.5C20.334 16.8 20.0923 16.2083 19.609 15.725C19.1257 15.2417 18.534 15 17.834 15C17.134 15 16.5423 15.2417 16.059 15.725C15.5757 16.2083 15.334 16.8 15.334 17.5C15.334 18.2 15.5757 18.7917 16.059 19.275C16.5423 19.7583 17.134 20 17.834 20ZM5.33398 19.5H9.33398V15.5H5.33398V19.5ZM10.384 9H14.284L12.334 5.85L10.384 9Z",
    fill: "#4D2481"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory);
export default __webpack_public_path__ + "static/media/category.0a7a122c748ca07aa1bc32ac6632df88.svg";
export { ForwardRef as ReactComponent };